import DT from 'duration-time-conversion';
import { parseTime } from '../../../shared/utils';
import copyTextToClipboard from '../../../helpers/copyTextToClipboard';

export default function copyActions(actions) {
  const data = actions
    .map((item, index) => {
      const startTimeSeconds = DT.t2d(item.startTime) + DT.t2d('00:00.100');
      const endTimeSeconds = DT.t2d(item.endTime) + DT.t2d('00:00.100');
      const speaker = `Action ${index + 1}:\n`;
      const timestamp = `(${parseTime(startTimeSeconds)} - ${parseTime(endTimeSeconds)}) `;
      return `${timestamp}${speaker}${item.text.replace(/\s+/g, ' ')}`;
    })
    .join('\n\n');
  copyTextToClipboard(data);
}
